import React from 'react';

import { Container } from 'src/components/Container';
import { AlertCopy } from './AlertCopy';
import { Modal } from 'src/components/Modal/Modal';
import ListItemRenderer from './ListItemRenderer';

import { formatFieldString } from 'src/components/Table/helpers';
import {
  DetailFieldBody,
  DetailFieldCard,
  DetailFieldLabel,
  DetailFieldValue,
  DetailFieldsList,
} from '../styled';

interface ItemDetailsModalProps {
  item: { [key: string]: any };
  title?: string;
  currencies?: any;
  children?: React.ReactNode;
  onClose: () => void;
}

const ItemDetailsModal: React.FC<ItemDetailsModalProps> = ({ item, title, children, onClose }) => {
  const renderField = (key: string, value: any, parentKey = '') => {
    const fieldKey = parentKey ? `${parentKey}.${key}` : key;

    if (typeof value === 'string' || typeof value === 'number') {
      return (
        <DetailFieldCard key={fieldKey}>
          <DetailFieldBody>
            <DetailFieldLabel>{formatFieldString(fieldKey)}</DetailFieldLabel>
            <DetailFieldValue>
              <ListItemRenderer item={item} field={fieldKey} isModal />
            </DetailFieldValue>
          </DetailFieldBody>
        </DetailFieldCard>
      );
    }

    return null;
  };

  return (
    <Modal isOpen onClose={onClose}>
      {title && (
        <Container textAlign="center" fontWeight={600} fontSize="1.5rem">
          {title}
        </Container>
      )}
      <DetailFieldsList>
        {Object.entries(item).map(([key, value]) => renderField(key, value))}
      </DetailFieldsList>
      <AlertCopy />
      {children}
    </Modal>
  );
};

export default ItemDetailsModal;
